module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"WCBI Simple WebApp","short_name":"WCBI WebApp","icon":"src/images/icon.png","icon_options":{"purpose":"any maskable"},"start_url":"/","lang":"en","background_color":"#2149a5","theme_color":"#ffffff","display":"standalone","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"784670dfb8c643754316e08751056c0d"},
    }]
